export default __webpack_public_path__ + "failed-icon-light-color-change.svg";